import request from "@/utils/request";
import store from '@/store'

const EncodeUserInfo = store.getters.EncodeUserInfo

//搜索接口
export function apiSearch(params) {
  return request({
    url: 'api/elt-zw/sy/search',
    method: 'get',
    params
  })
}

//查询首页需要显示的事项办理信息列表
export function apiList() {
  return request({
    url: 'api/elt-zw/sxBl/sy/list',
    method: 'get'
  })
}

//查询首页需要展示的服务数据
export function apiFwList() {
  return request({
    url: 'api/elt-zw/fw/sy/list',
    method: 'get'
  })
}

//查询所有的事项办理主题分类信息
export function apiFlList() {
  return request({
    url: 'api/elt-zw/sxBl/fl/list',
    method: 'get'
  })
}


//获取事项办理分页数据集合-支持条件检索
export function apiSxBlFlList(params) {
  return request({
    url: 'api/elt-zw/sxBl/list',
    method: 'get',
    params
  })
}

//查询公共服务列表
export function apiFwFlList(params) {
  return request({
    url: 'api/elt-zw/fw/list',
    method: 'get',
    params
  })
}

//鄂链通收藏接口
export function apiSave(data) {
  return request({
    url: 'api/elt-zw/favs/dm/save',
    method: 'post',
    data
  })
}

//删除收藏接口
export function apiDeleteSave(data) {
  return request({
    url: 'api/elt-zw/favs/dm/delete',
    method: 'post',
    data
  })
}


//我的收藏列表
export function apifavsList(params) {
  return request({
    url: 'api/elt-zw/favs/dm/list',
    method: 'get',
    params
  })
}
//正式环境
//首页政策直达列表
// export function apiGetPolicies(params) {
//   return request({
//     url: 'api/portalwork-saas-gateway/cs-portalwork-second-develop-policy/apiservice/elt-zw/getPolicies?encodeUserInfo=' + EncodeUserInfo,
//     method: 'get',
//     params
//   })
// }

// //首页数据统计接口
// export function apiGetCount() {
//   return request({
//     url: 'api/portalwork-saas-gateway/cs-portalwork-second-develop-policy/apiservice/elt-zw/count?encodeUserInfo=' + EncodeUserInfo,
//     method: 'get'
//   })
// }

// //政策类型字典接口
// export function apiFindDictEnableList(params) {
//   return request({
//     url: 'api/portalwork-saas-gateway/cs-portalwork-second-develop-business/apiservice/man-data-dictionary/findDictEnableList?encodeUserInfo=' + EncodeUserInfo,
//     method: 'get',
//     params
//   })
// }

// //获取发布机构接口
// export function apiGetDeptListByOnline(params) {
//   return request({
//     url: 'api/portalwork-saas-gateway/cs-portalwork-second-develop-policy/apiservice/elt-zw/getDeptListByOnline?encodeUserInfo=' + EncodeUserInfo,
//     method: 'get',
//     params
//   })
// }

// //获取发布机构接口
// export function apiGetCfgPermitItemInfo(params) {
//   return request({
//     url: 'api/portalwork-saas-gateway/cs-portalwork-second-develop-policy/apiservice/elt-zw/getCfgPermitItemInfo?encodeUserInfo=' + EncodeUserInfo,
//     method: 'get',
//     params
//   })
// }

//测试环境
//首页政策直达列表
export function apiGetPolicies(params) {
  return request({
    url: 'zw/portalwork-lite-gateway/portalwork-policy/apiservice/elt-zw/getPolicies?encodeUserInfo=' + EncodeUserInfo,
    method: 'get',
    params
  })
}

//首页数据统计接口
export function apiGetCount() {
  return request({
    url: 'zw/portalwork-lite-gateway/portalwork-policy/apiservice/elt-zw/count?encodeUserInfo=' + EncodeUserInfo,
    method: 'get'
  })
}

//政策类型字典接口
export function apiFindDictEnableList(params) {
  return request({
    url: 'zw/portalwork-lite-gateway/portalwork-policy/apiservice/man-data-dictionary/findDictEnableList?encodeUserInfo=' + EncodeUserInfo,
    method: 'get',
    params
  })
}

//获取发布机构接口
export function apiGetDeptListByOnline(params) {
  return request({
    url: 'zw/portalwork-lite-gateway/portalwork-policy/apiservice/elt-zw/getDeptListByOnline?encodeUserInfo=' + EncodeUserInfo,
    method: 'get',
    params
  })
}

//获取发布机构接口
export function apiGetCfgPermitItemInfo(params) {
  return request({
    url: 'zw/portalwork-lite-gateway/portalwork-policy/apiservice/elt-zw/getCfgPermitItemInfo?encodeUserInfo=' + EncodeUserInfo,
    method: 'get',
    params
  })
}

//获取政策层级字典接口
export function apiFindDictEnableListOne(params) {
  return request({
    url: 'zw/portalwork-lite-gateway/portalwork-policy/apiservice/dictionary/findDictEnableList',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/government.js